import {
  Component, OnInit, ViewChild, ElementRef, EventEmitter,
  Output, Input, SimpleChanges, OnChanges, DoCheck, SimpleChange, ChangeDetectorRef
} from '@angular/core';
import {EsriLoaderService} from '@services/esri-loader.service'
import {SearchService} from "@services/search.service";
import {ISearchObj} from "@models/search.interface";
import {environment} from '@env/environment';


@Component({
  selector: 'app-map-container',
  templateUrl: './map-container.component.html',
  styleUrls: ['./map-container.component.scss']
})

export class MapContainerComponent implements OnInit, OnChanges, DoCheck {
  @Output() extentChangedEvent: EventEmitter<any> = new EventEmitter();
  @Output() mapMoveEvent: EventEmitter<any> = new EventEmitter();
  @ViewChild('mapViewNode') private mapViewEl: ElementRef;
  @ViewChild('poly-button') private polyButtonEl: ElementRef;

  @Input()
  resultObject: any;
  resultObject1: ISearchObj;
  rows:any;
  rowCount:number = 0;
  esriService: EsriLoaderService;
  searchService: SearchService;
  mapView;
  // map;
  portalWebMap;
  portalImageryMap;
  extent;
  selectedFeatureLayer;
  selectedFeatureLyrFeilds;
  selectedFeatureLyrRenderer;
  markerSymbol;
  selectedSymbol;
  latLonSpatRef;
  useMapGeometryCbx:boolean = false;
  mapGeometryRadBx:string;
  polygonDrawAction;
  esriDrawEventHook;
  drawing:boolean = false;
  geographicPoly;
  popupTemplate;
  graphicsCollection;
  searchInProgress;

  parcelFeatureLayer;
  parcelLayerView;
  parcelLayerViewHighlightHandler;

  
  

  constructor(private service: EsriLoaderService,  private searchSvc: SearchService) {
    this.esriService = service;
    this.searchService = searchSvc;
    
    this.mapSetup();

 }

 mapGeomCbxChanged(){

  this.mapView.popup.close();
  this.esriService.selectedAccountNumber.next(null);

  if (this.parcelLayerViewHighlightHandler){
    this.parcelLayerViewHighlightHandler.remove();
  }
;
  if (this.useMapGeometryCbx && this.mapGeometryRadBx != 'graphic'){
    this.mapGeometryRadBx = 'extent';
  }else{
    this.clearGraphics();
  }
 }
 
 ngOnChanges(changes: SimpleChanges) {
   const result: SimpleChange = changes.resultObject;
   if(result.currentValue){
     this.updateMapResults(result.currentValue);
   }

   if (!this.useMapGeometryCbx){
     this.mapGeometryRadBx = 'none';
   }
 }


 /**
  *  Check for and respond to new selected rows. 
  */
  ngDoCheck() {

   /* if(this.resultObject){
      this.updateMapResults();
    } 

    if (!this.useMapGeometryCbx){
      this.mapGeometryRadBx = 'none';
    }*/
  }

  updateMapResults(result:any){
    if (result){
      if (!this.graphicsCollection){
        this.graphicsCollection = new this.esriService.esri.EsriCollection();
      }

      if(this.rowCount != result.length){
        this.rowCount = result.length;
        this.rows = result;
        
        this.loadData();
      }
    }
  }

  /**
   * Respond to radio button binding change. 
   */
  searchTypeChanged(){


    this.mapView.popup.close();
    this.esriService.selectedAccountNumber.next(null);

    if (this.parcelLayerViewHighlightHandler){
      this.parcelLayerViewHighlightHandler.remove();
    }

    if (this.mapGeometryRadBx=="graphic"){
      this.polygonDrawAction = this.esriDrawEventHook.create("polygon");
      this.mapView.focus();
      this.polygonDrawAction.on("vertex-add", (evt) =>{
        this.drawing = true;
        this.createPolygonGraphic(evt.vertices);
      });

      this.polygonDrawAction.on("draw-complete", (evt) =>{
        this.setDrawnSelectionPoly(evt.vertices);
        this.createPolygonGraphic(evt.vertices);
        
        this.drawing = false;
        this.mapGeometryRadBx = 'none';

      });
    }else if (this.mapGeometryRadBx=="extent"){
      this.drawing = false;
   
      if (this.mapView){
        this.mapView.graphics.removeAll();
      }
    }
  }


  /**
   * Load selected Account features in this.rows
   */
  loadData() {

    this.graphicsCollection.removeAll();
    this.mapView.popup.close();
    this.esriService.selectedAccountNumber.next(null);

    if (this.parcelLayerViewHighlightHandler){
      this.parcelLayerViewHighlightHandler.remove();
    }

    this.rows.forEach(row => {
      
      var y = row.geo_location.split(',')[0];
      var x = row.geo_location.split(',')[1];

      if (x != undefined && y != undefined){

        var point = new this.esriService.esri.Point(x, y, this.latLonSpatRef);
        var webMercPoint = this.esriService.esri.webMercatorUtils.geographicToWebMercator(point);

        var pointGraphic = new this.esriService.esri.Graphic({
          geometry: webMercPoint,
          // symbol: this.markerSymbol,
          attributes: row
          // popupTemplate: this.popupTemplate
        });
        this.graphicsCollection.add(pointGraphic);
      }
    });

    
    this.portalWebMap.remove(this.selectedFeatureLayer);
    // this.map.remove(this.selectedFeatureLayer);


    this.selectedFeatureLayer = new this.esriService.esri.FeatureLayer({
      fields: this.selectedFeatureLyrFeilds,
      objectIdField: "ObjectID",
      spatialReference: this.latLonSpatRef,
      renderer: this.selectedFeatureLyrRenderer,
      popupTemplate: this.popupTemplate,
      source: this.graphicsCollection,
      geometryType: "point",
      refreshInterval:0.1
    });

    this.portalWebMap.add(this.selectedFeatureLayer);

    this.mapView.whenLayerView(this.selectedFeatureLayer).then(() => {
      if (this.mapGeometryRadBx != 'extent')
      {
        if (this.selectedFeatureLayer.source.items.length > 0){
          this.mapView.goTo(this.selectedFeatureLayer.fullExtent);
        } else {
          this.mapView.goTo({
            center: [-104.86243196377545, 39.42203081529452],
            zoom: 11
          });

        }
      }
    });

    // this.mapView.when(x => {


    // });
  }



  setupSelectedFLayer(){

    this.selectedFeatureLyrFeilds = [
      new this.esriService.esri.Field({
        name: "ObjectID",
        alias: "ObjectID",
        type: "oid"
      }), new this.esriService.esri.Field({
        name: "account_number",
        alias: "account_number",
        type: "string"
      }), new this.esriService.esri.Field ({
        name: "account_type",
        alias: "account_type",
        type: "string"
      }), new this.esriService.esri.Field ({
        name: "actual_value_sum",
        alias: "actual_value_sum",
        type: "integer"
      }), new this.esriService.esri.Field ({
        name: "assessed_value_sum",
        alias: "assessed_value_sum",
        type: "integer"
      }), new this.esriService.esri.Field ({
        name: "legal_description",
        alias: "legal_description",
        type: "string"
      }), new this.esriService.esri.Field ({
        name: "primary_address_city",
        alias: "primary_address_city",
        type: "string"
      }), new this.esriService.esri.Field ({
        name: "primary_address_street_address",
        alias: "primary_address_street_address",
        type: "string"
      }), new this.esriService.esri.Field ({
        name: "primary_address_unit_number",
        alias: "primary_address_unit_number",
        type: "string"
      }), new this.esriService.esri.Field ({
        name: "primary_address_zip_code",
        alias: "primary_address_zip_code",
        type: "string"
      }), new this.esriService.esri.Field ({
        name: "primary_owner_name",
        alias: "primary_owner_name",
        type: "string"
      }), new this.esriService.esri.Field({
        name:"state_parcel_number",
        alias: "state_parcel_number",
        type: "string"
      })
     ];

    this.markerSymbol = {
      type: "simple-marker", // autocasts as new SimpleMarkerSymbol()
      color: [226, 119, 40],
      size: 8,
      outline: { // autocasts as new SimpleLineSymbol()
        color: [255, 255, 255],
        width: 1
      }
    };

    this.selectedFeatureLyrRenderer = {
      type: "simple",
      symbol: this.markerSymbol
    };


    this.graphicsCollection = new this.esriService.esri.EsriCollection();
    this.latLonSpatRef = new this.esriService.esri.SpatialReference({ wkid: 4326 });
    this.selectedFeatureLayer = new this.esriService.esri.FeatureLayer({
      fields: this.selectedFeatureLyrFeilds,
      objectIdField: "ObjectID",
      spatialReference: this.latLonSpatRef,
      renderer: this.selectedFeatureLyrRenderer,
      popupTemplate: this.popupTemplate,
      source: this.graphicsCollection,
      geometryType: "point",
      refreshInterval:0.1
    });

    this.portalWebMap.add(this.selectedFeatureLayer);
    // this.map.add(this.selectedFeatureLayer);

  }

  /**
   * Subscribe to service events. 
   */
  ngOnInit() {
    this.esriService.selectedItem.subscribe({
      next:(newVal: any) => {
        this.selectGraphic(newVal.account_number);
      }
    });

    this.esriService.resetForm.subscribe({
      next:(newVal: boolean) => {
        if (newVal) {
          this.rows = [];
          this.rowCount = 0;
          this.clearGraphics();
          this.loadData();
        }
      }
    });
  }

  /**
   * Clear all graphics from the Graphics Layer 
   * and the map graphics layer
   */
  clearGraphics(){

    this.mapView.popup.close();
    this.esriService.selectedAccountNumber.next(null);

    if (this.parcelLayerViewHighlightHandler){
      this.parcelLayerViewHighlightHandler.remove();
    }

    this.drawing = false;
   
    if (this.mapView){
      this.mapView.graphics.removeAll();
    }
    this.useMapGeometryCbx = false;
    this.mapGeometryRadBx = 'none';
    this.esriService.resetForm.next(false);

    // Clear the map extent and make sure it is cleared in the
    // Search Service by emiting the extentChangedEvent.
    this.extent = null;
    this.extentChangedEvent.emit(null);
  }


  /**
   * Find graphic by account number,
   * Select graphic, open associated popup 
   * and zoom to location. 
   *  
   * @param accountNum 
   */
  selectGraphic(accountNum:string){

    if (this.selectedFeatureLayer){
      var queryParams = this.selectedFeatureLayer.createQuery();
      queryParams.where = "account_number = '" + accountNum + "'";

      this.selectedFeatureLayer.queryFeatures(queryParams).then((results) => {
        results.features.forEach(feature => {
          this.selectParcel(feature.attributes.state_parcel_number);
          this.mapView.goTo(feature.geometry);
          this.mapView.popup.open({
            location:feature.geometry,
            features:[feature]
          });
        });
      });
    }
  }

  selectParcel(parcel_number:string){

    if (this.parcelFeatureLayer && this.parcelLayerView){
     
      if (this.parcelLayerViewHighlightHandler){
        this.parcelLayerViewHighlightHandler.remove();
      }

      var queryParams = this.parcelFeatureLayer.createQuery();
      queryParams.where = "PARCEL_SPN = '" + parcel_number + "'";
      this.parcelFeatureLayer.queryFeatures(queryParams).then((results) => {
        results.features.forEach(feature => {
          this.parcelLayerViewHighlightHandler = this.parcelLayerView.highlight(feature);
        })
      });
    }

  }

  

  /**
   * Wait for esri libraries to load, then define basemaps
   * feature layers and widgets. 
   */
  mapSetup(){

    this.esriService.loadEsriObjects().then(() => {
      this.esriService.esri.Config.portalUrl = environment.dcportal;
      console.log('dcportal: ' + environment.dcportal);
      this.portalWebMap = new this.esriService.esri.WebMap({
        portalItem: {
          // id: "b9cd0315feea498da0cf6b047e35d491"
          // id: "7b901f4b00c446bdb0e70506d5f12af1"    //new portal = portal instead of dcportal
          id: "4b399e1161b5433586c688f57775ca7a"    //new portal = gisportal instead of portal
        }
      });

      this.portalImageryMap = new this.esriService.esri.Basemap({
        portalItem: {
          // id: "6776de00253c441ea2877f720bbb6f75"
          // id: "d9d1fbc5177b4607951d5b2ba5e6035d"    //new portal = portal instead of dcportal
          id: "5406aecf98cb489eb286b827853d7bc8"    //new portal = gisportal instead of portal
        }
      });

      this.parcelFeatureLayer = new this.esriService.esri.FeatureLayer({
        portalItem: {
          // id: "bd3c4f65953d4a5f83e5db9c0c96473e"
          // id: "727df53a45064b2e97febf18f61f90e9"   //new portal = portal instead of dcportal
          //id: "96044c6ac73d4303986574689c64bef9"    //new portal = gisportal instead of portal
          id: "ffe6cc0c8df34e328081ae27504bc66e"
        },
        layerId:0,
        minScale:10000,
        outFields: ["PARCEL_SPN"]
      });

      this.mapView = new this.esriService.esri.MapView({
        container: this.mapViewEl.nativeElement,
        center: [-104.86243196377545, 39.42203081529452],
        zoom: 11,
        map: this.portalWebMap
      });

      this.esriDrawEventHook = new this.esriService.esri.Draw({
         view: this.mapView
       });

       var homeWidget = new this.esriService.esri.HomeWidget({
         view: this.mapView
       });

       var basemapToggle = new this.esriService.esri.BasemapToggle({
         view: this.mapView,
         nextBasemap: this.portalImageryMap
       });

       this.mapView.ui.add(homeWidget, "top-left");
       this.mapView.ui.add(basemapToggle, "bottom-right");


       this.mapView.popup.dockOptions = {
        // Disable the dock button so users cannot undock the popup
        buttonEnabled: false,
        // Dock the popup when the size of the view is less than or equal to 600x1000 pixels
        breakpoint: {
          width: 600,
          height: 1000
        }
      };


      this.parcelFeatureLayer.minScale = 10000;
      this.portalWebMap.add(this.parcelFeatureLayer);
      this.mapView.whenLayerView(this.parcelFeatureLayer).then((result) => {
        this.parcelLayerView = result;
      });

      this.wireEvents();
      this.setupMapWatchers();
      this.setupGraphics();
      this.setupSelectedFLayer();
    });
  }

  /**
   * Set up selection symbol and marker symbol defaults. 
   */
  setupGraphics(){

    this.latLonSpatRef = new this.esriService.esri.SpatialReference({ wkid: 4326 });


    this.markerSymbol = {
      type: "simple-marker", // autocasts as new SimpleMarkerSymbol()
      color: [226, 119, 40],
      size: 8,
      outline: { // autocasts as new SimpleLineSymbol()
        color: [255, 255, 255],
        width: 1
      }
    };

    this.selectedSymbol = {
      type: "simple-marker", // autocasts as new SimpleMarkerSymbol()
      color: [226, 0, 0],
      size: 8,
      outline: { // autocasts as new SimpleLineSymbol()
        color: [255, 0, 0],
        width: 1
      }
    };

    var currentYear = new Date().getFullYear();
    this.popupTemplate = { // autocasts as new PopupTemplate()
      title: "{primary_owner_name}",
      content: "<table>" + 
        "<tr><td style='white-space:nowrap;'>{primary_address_street_address}</td></tr>" +
        "<tr><td style='white-space:npopupTemplateowrap;'>{primary_address_city}, {primary_address_zip_code}</td></tr>" +
        "<tr><td>Account: {account_number}</td></tr>" +
        "<tr><td><a target='_newwellwin' href='http://apps.douglas.co.us/assessor/web/#/details/"+currentYear+"/{account_number}'><u>Show details for this property</u></a></td></tr>" +
      "</table>"
      };
   }

   /**
    * Connect map based event listeners. 
    */
   wireEvents(){

    this.mapView.on("pointer-up", (event) => {
      if (!this.drawing && this.useMapGeometryCbx){
        this.mapMoveEvent.emit();
      }
    });

    this.mapView.on("click", (evt) =>{

      this.mapView.hitTest(evt).then((response) => {

        // Make sure you are getting the attributes from the correct layer.
        var resultsFeature;
        var resultsMemoryAttributes;
        var foundAccountNum;
        var foundParcelNum;

        response.results.forEach(layer => {

          if (layer.graphic.sourceLayer){
            if (layer.graphic.sourceLayer.source.type == 'feature-layer'){
              resultsFeature = layer.graphic;
            }

            if (layer.graphic.sourceLayer.source.type == 'memory'){
              resultsMemoryAttributes = layer.graphic.attributes;
            }

            // use in memory graphic if clicked.
            if (resultsMemoryAttributes){
              foundAccountNum = resultsMemoryAttributes.account_number;
              foundParcelNum = resultsMemoryAttributes.state_parcel_number;
            } else {
              // Else use parcel to get account
              if (resultsFeature){
                foundParcelNum = resultsFeature.attributes.parcel_spn;

                var queryParams = this.selectedFeatureLayer.createQuery();
                queryParams.where = "state_parcel_number = '" + foundParcelNum + "'";
                this.selectedFeatureLayer.queryFeatures(queryParams).then((results) => {
                  var foundFeature = results.features[0];
                  if (foundFeature){
                    this.mapView.popup.open({
                      location:foundFeature.geometry,
                      features:[foundFeature]
                    });
                    this.esriService.selectedAccountNumber.next(foundFeature.attributes.account_number);
                  }else{
                    this.esriService.selectedAccountNumber.next(null);
                  }
                });
              }
            }

            if (foundParcelNum){
              this.selectParcel(foundParcelNum);
            }

            if (foundAccountNum){
              this.esriService.selectedAccountNumber.next(foundAccountNum);
            }

          }
        });
      });
  
    });
  }


  /**
   *  Set up watcher event listeners on map properties
   */
  setupMapWatchers(){

    this.extent = this.mapView.watch ("extent, center", 
      (newValue, oldValue, propertyName) => {

        if (this.mapGeometryRadBx == 'extent'){
          var webMercExtent = this.mapView.extent;
          var geoExtent = this.esriService.esri.webMercatorUtils.webMercatorToGeographic(webMercExtent);

          var extentObj = {'geo_polygon':{'geo_location':{'points':
          [
            [geoExtent.xmin,  geoExtent.ymin],
            [geoExtent.xmax, geoExtent.ymin],
            [geoExtent.xmax,  geoExtent.ymax],
            [geoExtent.xmin, geoExtent.ymax]
          ]}}};;

          if(this.useMapGeometryCbx){
            this.extentChangedEvent.emit(extentObj);
          } else {
            this.extentChangedEvent.emit(null);
          }
        }
      });
   }


   /**
    * Set the polygon object to be used in the 
    * Elasticsearch query
    * 
    * @param vertecies 
    */
   setDrawnSelectionPoly(vertecies){

    var geoPoints = [];
    vertecies.forEach(element => {
      var x = element[0];
      var y = element[1];
      var point = {
        type: "point", // autocasts as Polygon
        x: x,
        y: y,
        spatialReference: this.mapView.spatialReference
      };
      var geographicPoint = this.esriService.esri.webMercatorUtils.webMercatorToGeographic(point, false);
      var geoPoint = [geographicPoint.x, geographicPoint.y];
      geoPoints.push(geoPoint);
    });

    var drawnPolyObject = 
    {'geo_polygon':
       {'geo_location':
         {'points':
           geoPoints
         }
       }
     };

     if(this.useMapGeometryCbx){
      this.extentChangedEvent.emit(drawnPolyObject);
    } else {
      this.extentChangedEvent.emit(null);
    }
   }



   /**
    * Creates a graphic polygon object from a collection of vericies
    * and adds it to the graphic layer of the MapVIew
    * 
    * @param vertices 
    */
   createPolygonGraphic(vertices){
    this.mapView.graphics.removeAll();
    var poly = {
      type: "polygon", // autocasts as Polygon
      rings: vertices,
      spatialReference: this.mapView.spatialReference
    };

    this.geographicPoly = this.esriService.esri.webMercatorUtils.webMercatorToGeographic(poly, false);
    var graphic = new this.esriService.esri.Graphic({
      geometry: poly,
      symbol: {
        type: "simple-fill", // autocasts as SimpleFillSymbol
        color: "purple",
        style: "none",
        outline: {  // autocasts as SimpleLineSymbol
          color: "blue",
          width: 3
        }
      }
    });
    this.mapView.graphics.add(graphic);
  }
}
